import React from 'react'
import Layout from '@/product/components/templates/Layout'

const NoFound = (props) => {
    return (
        <Layout>
            {props?.noAuth ? (
                <div>
                    <h1>404</h1>
                    <h2>Access Denied</h2>
                    <p>
                        You do not have permission to access this page. Please
                        contact your administrator for assistance.
                    </p>
                </div>
            ) : (
                <div>
                    <h1>404</h1>
                    <h2>Page Not Found</h2>
                    <p>
                        We apologize, but the page you are trying to access
                        cannot be found. Please verify the URL or navigate back
                        to the homepage.
                    </p>
                </div>
            )}
        </Layout>
    )
}

export default NoFound
